import React from 'react';
import { CheckCircle, Clock, ThumbsUp, Headphones, Shield } from 'lucide-react';
const WhyChooseUsSection = () => {
  const reasons = [{
    icon: <CheckCircle className="w-6 h-6" data-id="element-344" data-mp="1bbs70gb3gss4" />,
    title: 'Certified Expertise',
    description: 'Our technicians are certified by leading manufacturers and undergo continuous training to stay current with the latest technologies.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-345" data-mp="1z6utihmfek5f" />,
    title: 'Prompt & Reliable',
    description: 'We value your time and pride ourselves on punctual service with clear communication throughout your project.'
  }, {
    icon: <div className="w-6 h-6" data-id="element-346" data-mp="27zokhcb8j7z4" />,
    title: 'Quality Installations',
    description: 'We use only premium materials and follow industry best practices to ensure your systems perform flawlessly for years.'
  }, {
    icon: <ThumbsUp className="w-6 h-6" data-id="element-347" data-mp="2czayhnyw0s8z" />,
    title: 'Satisfaction Guaranteed',
    description: 'We stand behind our work with comprehensive warranties and ongoing support for all installations.'
  }, {
    icon: <Headphones className="w-6 h-6" data-id="element-348" data-mp="30qzp1gel9o9u" />,
    title: 'Responsive Support',
    description: 'Our dedicated support team is available to quickly address any questions or concerns you may have.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-349" data-mp="39u0stafzf3ac" />,
    title: 'Licensed & Insured',
    description: 'Your protected because we carry insurance coverage and are state licensing.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-350" data-mp="3jp2hy6a9c5cx">
      <div className="container mx-auto px-4" data-id="element-351" data-mp="3ohlvx4cux2i9">
        <div className="text-center mb-16" data-id="element-352" data-mp="3ohvn2v9n1fpj">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-353" data-mp="3tgglcp5bxpbc">WHY CHOOSE US</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-354" data-mp="3tijal6ynref0">
            The Premier Choice for AV & Smart Technology
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-355" data-mp="6bh7krvq0xp1">
            With over 20 years of experience serving Southwest Florida, we
            deliver exceptional results through expertise, quality, and
            outstanding customer service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10" data-id="element-356" data-mp="1ybh0eg1vfwfp">
          {reasons.map((reason, index) => <div key={index} className="flex" data-id="element-357" data-mp="27dq7sx1uf9ov" data-mpi={index}>
              <div className="mr-4 text-blue-600 flex-shrink-0" data-id="element-358" data-mp="27bvmhhmntfk9">
                {reason.icon}
              </div>
              <div data-id="element-359" data-mp="2m4pf84qxzs6v">
                <h3 className="text-xl font-bold mb-2" data-id="element-360" data-mp="2h41lhbbbwx8y">{reason.title}</h3>
                <p className="text-gray-600" data-id="element-361" data-mp="2h64b3u8kkod5">{reason.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-16 bg-gray-50 rounded-xl p-8 md:p-12" data-id="element-362" data-mp="2q3y8z9lzfq2f">
          <div className="flex flex-col md:flex-row items-center" data-id="element-363" data-mp="2q2n416gswc9q">
            <div className="w-full md:w-2/3 mb-8 md:mb-0 md:pr-12" data-id="element-364" data-mp="10q1r0fv95zt3">
              <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-365" data-mp="vr8dinfyu8sx">
                Our Process Makes Technology Simple
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-366" data-mp="37ek8nq0n26ve">
                We take the complexity out of technology by following a proven
                process designed to deliver exceptional results with minimal
                disruption to your home or business.
              </p>
              <div className="space-y-4" data-id="element-367" data-mp="32m0mi4nvy3ez">
                {[{
                number: '01',
                title: 'Consultation & Design',
                desc: 'We learn your needs and create a custom solution'
              }, {
                number: '02',
                title: 'Professional Installation',
                desc: 'Expert technicians install with precision and care'
              }, {
                number: '03',
                title: 'System Programming',
                desc: 'Custom programming for intuitive control'
              }, {
                number: '04',
                title: 'Training & Support',
                desc: "We ensure you're comfortable with your new technology"
              }].map((step, idx) => <div key={idx} className="flex" data-id="element-368" data-mp="3fbu3auwy0r5a" data-mpi={idx}>
                    <div className="mr-4 bg-blue-600 rounded-full w-10 h-10 flex items-center justify-center flex-shrink-0" data-id="element-369" data-mp="3aettc8wz348w">
                      <span className="text-white font-bold" data-id="element-370" data-mp="36ds1id5dxugy">
                        {step.number}
                      </span>
                    </div>
                    <div data-id="element-371" data-mp="2wmx72lhzjokf">
                      <h4 className="font-bold text-gray-800" data-id="element-372" data-mp="2wm4846p9q3cu">{step.title}</h4>
                      <p className="text-gray-600 text-sm" data-id="element-373" data-mp="2ro2o9jk0q00b">{step.desc}</p>
                    </div>
                  </div>)}
              </div>
            </div>
            <div className="w-full md:w-1/3" data-id="element-374" data-mp="2mqu7nneiq416">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1aajRYC6DBrUabo7bRuUJ3/smarthomesystem.jpg" alt="Smart home control panel with lighting, security, temperature and camera controls" className="rounded-xl shadow-md w-full h-auto" data-id="element-375" data-mp="2imw5f3twcd3w" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default WhyChooseUsSection;